<template>
    <div>
        <v-dialog v-model="dialog" width="500px">
            <v-card>
                <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
                <br>
                <v-card-text>Are you sure you want the remove task "{{ taak_code }}" ?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="warning mx-2" small v-on:click="rmTaak">Yes</v-btn>
                    <v-btn color="success" small @click="dialog = false">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
                taak_encrid: '',
                taak_code: '',
            }
        },
        methods: {
            open(taak_encrid, taak_code) {
                this.taak_encrid = taak_encrid;
                this.taak_code = taak_code;
                this.dialog = true;
            },
            rmTaak() {
                this.$axios
                    .post("ares/json/ares/syst/authorization/rmTaak.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "rmTaak"
                        },
                        rmTaak: {
                            taak_encrid: this.taak_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.$emit('updateData', 'refresh');
                            this.dialog = false;
                        }
                    })
            },
        },
    }
</script>
